import { eventBus } from "@/plugins/eventBus";
export default {
  state: {
    pageTimers: {},
    hasNavBar: false,
    navList: [],
  },

  getters: {
    cachedViews: (state) => {
      const navList = state.navList || [];
      // 既要包含自身 又要包含父页面的name
      let result = [];
      navList.map((item) => {
        result.push(item.componentName);
        if (
          item.pComponentName != "Home" &&
          !navList.find((i) => i.componentName == item.pComponentName)
        ) {
          result.push(item.pComponentName);
        }
      });
      return result;
    },
  },

  mutations: {
    // 设置导航标签
    SET_NAV_LIST: (state, navList) => {
      state.navList = navList;
    },

    // 添加导航标签
    ADD_NAV_LIST: (state, data) => {
      let index = state.navList.findIndex((item) => item.path === data.path);
      if (index === -1) {
        state.navList.push(data);
      } else {
        state.navList[index] = data;
      }
    },

    // 删除导航标签
    DEL_NAV_LIST: (state, data) => {
      let index = state.navList.findIndex((item) => item.path === data);
      state.navList.splice(index, 1);
      let emitName = "call-" + data + "-function";
      eventBus.$emit(emitName);
    },

    // 清空导航标签
    CLEAR_NAV_LIST: (state) => {
      state.navList = [];
    },

    // 添加定时器
    ADD_TIMER: (state, { view, timerId }) => {
      if (!state.pageTimers[view]) {
        state.pageTimers[view] = [];
      }

      state.pageTimers[view].push(timerId);
    },

    // 删除定时器
    REMOVE_TIMER: (state, { view, timerId }) => {
      if (state.pageTimers[view]) {
        const index = state.pageTimers[view].indexOf(timerId);

        if (index > -1) {
          state.pageTimers[view].splice(index, 1);
        }
      }
    },

    // 清空定时器
    DEL_ALL_CACHED_VIEWS: (state) => {
      Object.values(state.pageTimers).forEach((timers) => {
        timers.forEach((timerId) => {
          clearInterval(timerId);

          clearTimeout(timerId);
        });
      });
      state.pageTimers = {};
      state.navList = [];
    },

    // 设置导航模式
    SET_HAS_NAV_BAR: (state, hasNavBar) => {
      state.hasNavBar = hasNavBar;
    },
  },
};
